export default __webpack_public_path__ + "static/media/user.95b7ef9d.gif";